export default function Messages() {
  return <div>Messages</div>;
}
